<template>
  <v-btn
    @click="onClickDownloadXml"
    :loading="loading"
    class="normal-btn-text elevation-0 rounded-tag-small"
    small
  >
    XML
  </v-btn>
</template>

<script>
import NotasFiscaisService from '@/modules/notas-fiscais/notas-fiscais-service';

export default {
  props: {
    notaFiscal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onClickDownloadXml() {
      this.loading = true;
      NotasFiscaisService.getXml(this.notaFiscal.id)
        .then(({ data }) => {
          const linkSource = `data:application/pdf;base64,${data}`;
          const downloadLink = document.createElement('a');
          const fileName = `xml-${this.notaFiscal.chaveAcesso}.xml`;

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>;
